import routeEdit from "./routeEdit.component";
import routeEditUrls from "./routeEdit.urls";
import RouteEditTransforms from "./routeEdit.transforms";

const routeEditModule = angular
  .module("app.components.routeEdit", [])
  .component("routeEditPage", routeEdit)
  .service("RouteEditTransforms", RouteEditTransforms)
  .config(routeEditUrls);

export default routeEditModule;



// WEBPACK FOOTER //
// ./src/pages/routeEdit/routeEdit.module.js